import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconCloudUpload.tsx
const OutlinedFilledCloudUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M444-135H253q-97 0-166.5-68T17-369q0-84 51-150.5T201-600q24-100 102-162.5T482-825q116 0 198 82.5T770-543v24q75 7 124 60.5T943-327q0 80-56 136t-136 56H516v-306l88 89 52-50-176-176-175 176 51 50 88-89v306Z" })
});
const OutlinedCloudUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M252-135q-96.34 0-165.67-68.68Q17-272.35 17-368q0-84 50.5-151T201-600q24-100 102.17-162.5T482.29-825Q599-825 680.5-742.5 762-660 770-543v24q75 7 124 60.7 49 53.71 49 131.3 0 79.92-57.5 135.96Q828-135 749-135H539q-38.98 0-66.99-27.99Q444-190.97 444-229v-212l-88 89-51-50 175-176 176 176-52 50-88-89v212h233.36Q789-229 819-258.87T849-329q0-41-29.87-70.5T749-429h-72v-95q0-84.43-57.15-145.22Q562.71-730 478.47-730 392-730 335-665.5T278-513h-28q-58.27 0-98.64 40.81-40.36 40.81-40.36 101Q111-313 152.44-271t100.06 42H384v94H252Zm228-298Z" })
});
const RoundedFilledCloudUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M253-135q-97 0-166.5-68T17-369q0-84 51-150.5T201-600q24-100 102-162.5T482-825q116 0 198 82.5T770-543v24q75 7 124 60.5T943-327q0 80-56 136t-136 56H516v-306l64 64q10 11 24 11t25-10q11-11 11.5-26T630-428L514-545q-14-14-34-14t-34 14L329-427q-11 11-10 25.5t12 24.5q11 11 25.5 10.5T382-378l62-63v306H253Z" })
});
const RoundedCloudUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m444-441-63 64q-11.5 11-25.42 11-13.91 0-24.58-10-11-11-11.5-26t10.5-26l116-117q14.73-14 34.36-14Q500-559 514-545l117 118q11 11 10.5 25.5T630.43-377q-11.61 11.08-26.02 10.54Q590-367 580-378l-64-63v212h233.36Q789-229 819-258.87T849-329q0-41-29.87-70.5T749-429h-72v-95q0-84.43-57.15-145.22Q562.71-730 478.47-730 392-730 335-665.5T278-513h-28q-58.27 0-98.64 40.81-40.36 40.81-40.36 101Q111-313 152.29-271q41.3 42 99.71 42h85q19.75 0 33.38 13.68Q384-201.65 384-181.82q0 19.82-13.62 33.32Q356.75-135 337-135h-85q-96.34 0-165.67-68.68Q17-272.35 17-368q0-84 50.5-151T201-600q24-100 102.17-162.5T482.29-825Q599-825 680.5-742.5 762-660 770-543v24q75 7 124 60.7 49 53.71 49 131.3 0 79.92-57.5 135.96Q828-135 749-135H539q-38.98 0-66.99-27.99Q444-190.97 444-229v-212Zm36 8Z" })
});
const SharpFilledCloudUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M444-135H253q-97 0-166.5-68T17-369q0-84 51-150.5T201-600q24-100 102-162.5T482-825q116 0 198 82.5T770-543v24q75 7 124 60.5T943-327q0 80-56 136t-136 56H516v-306l88 89 52-50-176-176-175 176 51 50 88-89v306Z" })
});
const SharpCloudUpload = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M252-135q-96.34 0-165.67-68.68Q17-272.35 17-368q0-84 50.5-151T201-600q24-100 102.17-162.5T482.29-825Q599-825 680.5-742.5 762-660 770-543v24q75 7 124 60.7 49 53.71 49 131.3 0 79.92-57.5 135.96Q828-135 749-135H539q-38.98 0-66.99-27.99Q444-190.97 444-229v-212l-88 89-51-50 175-176 176 176-52 50-88-89v212h233.36Q789-229 819-258.87T849-329q0-41-29.87-70.5T749-429h-72v-95q0-84.43-57.15-145.22Q562.71-730 478.47-730 392-730 335-665.5T278-513h-28q-58.27 0-98.64 40.81-40.36 40.81-40.36 101Q111-313 152.44-271t100.06 42H384v94H252Zm228-298Z" })
});
const componentMap = {
	outlined: OutlinedCloudUpload,
	"outlined-fill": OutlinedFilledCloudUpload,
	rounded: RoundedCloudUpload,
	"rounded-fill": RoundedFilledCloudUpload,
	sharp: SharpCloudUpload,
	"sharp-fill": SharpFilledCloudUpload
};
const IconCloudUpload = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconCloudUpload };